export const QUICK = 'quick'
export const WEATHER = 'weather'
export const SNOWPACK = 'snowpack'
export const AVALANCHE = 'avalanche'
export const INCIDENT = 'incident'
